/*
 * @Description: 实时定位驾驶舱 — 请求层（接口前缀 /web/location/cockpit）
 *   驾驶舱信封为 { code, msg, toast_msg, data }，与旧 exceptionHelper 期望的
 *   { data: { status } } 结构不同，故此处不接 exceptionHelper，
 *   由调用方（hook）自行判 code===200；1002/1004 返回 data:null 视为空态非错误。
 */
/* eslint-disable */
import fetchHelper from '../utils/fetchHelper'
import { captureFetchException } from '../utils/sentryUtils'

// 驾驶舱接口统一前缀（接口文档第五节）
const COCKPIT_PREFIX = '/web/location/cockpit'

// A3 全员最新位置 —— POST /realtime/locations
export function fetchRealtimeLocations(data) {
  return (dispatch, getState) => {
    const config = {
      url: __API_SERVER_HOST__ + COCKPIT_PREFIX + '/realtime/locations',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config).catch((err) => {
      captureFetchException(err, config)
      return Promise.reject(null)
    })
  }
}

// A1 状态统计 —— POST /realtime/summary
export function fetchRealtimeSummary(data) {
  return (dispatch, getState) => {
    const config = {
      url: __API_SERVER_HOST__ + COCKPIT_PREFIX + '/realtime/summary',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config).catch((err) => {
      captureFetchException(err, config)
      return Promise.reject(null)
    })
  }
}

// A2 成员列表 —— POST /realtime/members
export function fetchRealtimeMembers(data) {
  return (dispatch, getState) => {
    const config = {
      url: __API_SERVER_HOST__ + COCKPIT_PREFIX + '/realtime/members',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config).catch((err) => {
      captureFetchException(err, config)
      return Promise.reject(null)
    })
  }
}

// A4 成员详情 —— POST /member/detail（userId 可为任意成员）
export function fetchMemberDetail(data) {
  return (dispatch, getState) => {
    const config = {
      url: __API_SERVER_HOST__ + COCKPIT_PREFIX + '/member/detail',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config).catch((err) => {
      captureFetchException(err, config)
      return Promise.reject(null)
    })
  }
}

// B1 团队轨迹 —— POST /track/team（startTime/endTime = unix 秒，跨度 ≤ 24h）
export function fetchTeamTrack(data) {
  return (dispatch, getState) => {
    const config = {
      url: __API_SERVER_HOST__ + COCKPIT_PREFIX + '/track/team',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config).catch((err) => {
      captureFetchException(err, config)
      return Promise.reject(null)
    })
  }
}

// B3 单成员完整轨迹/回放 —— POST /track/timeline（date=YYYY-MM-DD）
export function fetchTrackTimeline(data) {
  return (dispatch, getState) => {
    const config = {
      url: __API_SERVER_HOST__ + COCKPIT_PREFIX + '/track/timeline',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config).catch((err) => {
      captureFetchException(err, config)
      return Promise.reject(null)
    })
  }
}

// B4 轨迹统计 —— POST /track/stats（startTime/endTime = unix 秒）
export function fetchTrackStats(data) {
  return (dispatch, getState) => {
    const config = {
      url: __API_SERVER_HOST__ + COCKPIT_PREFIX + '/track/stats',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config).catch((err) => {
      captureFetchException(err, config)
      return Promise.reject(null)
    })
  }
}

// C1 事件流 —— POST /events/feed
export function fetchEventsFeed(data) {
  return (dispatch, getState) => {
    const config = {
      url: __API_SERVER_HOST__ + COCKPIT_PREFIX + '/events/feed',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config).catch((err) => {
      captureFetchException(err, config)
      return Promise.reject(null)
    })
  }
}

// POI / geo 端点统一构造（与上方一致：POST + JSON body + sentry 兜底）
function postCockpit(path, data) {
  return (dispatch, getState) => {
    const config = {
      url: __API_SERVER_HOST__ + COCKPIT_PREFIX + path,
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config).catch((err) => {
      captureFetchException(err, config)
      return Promise.reject(null)
    })
  }
}

// E1 POI 列表 —— POST /poi/list
export function fetchPoiList(data) {
  return postCockpit('/poi/list', data)
}

// E2 新增 / 编辑 —— POST /poi/save（id 省略或 0 = 新增）
export function savePoi(data) {
  return postCockpit('/poi/save', data)
}

// E3 删除（软删） —— POST /poi/delete
export function deletePoi(data) {
  return postCockpit('/poi/delete', data)
}

// E4 批量导入 —— POST /poi/import（web 解析 xlsx → JSON，≤50）
export function importPoi(data) {
  return postCockpit('/poi/import', data)
}

// F1 地点搜索 —— POST /geo/search（转发高德，展示用 name）
export function geoSearch(data) {
  return postCockpit('/geo/search', data)
}

// F2 地址 → 坐标 —— POST /geo/geocode
export function geocode(data) {
  return postCockpit('/geo/geocode', data)
}

// F3 坐标 → 地址 —— POST /geo/regeo
export function geoRegeo(data) {
  return postCockpit('/geo/regeo', data)
}

// G1 定位设置读取 —— POST /config/settings/get
export function fetchGroupSettings(data) {
  return postCockpit('/config/settings/get', data)
}

// G2 定位设置保存 —— POST /config/settings/save
export function saveGroupSettings(data) {
  return postCockpit('/config/settings/save', data)
}

// G3 告警规则读取 —— POST /config/alert-rules/get（返回四类规则，DB 未存的服务端合成默认）
export function fetchAlertRules(data) {
  return postCockpit('/config/alert-rules/get', data)
}

// G4 告警规则保存 —— POST /config/alert-rules/save（单条，(groupId,ruleType) 幂等 upsert）
export function saveAlertRule(data) {
  return postCockpit('/config/alert-rules/save', data)
}

// C1' 告警动态流 —— POST /alerts/feed（覆盖全 7 类规则，卡片结构同 C1）
export function fetchAlertsFeed(data) {
  return postCockpit('/alerts/feed', data)
}

// D1 告警记录列表 —— POST /alerts/list（透传 ListAlerts，时间段/类型/成员/状态筛选）
export function fetchAlertsList(data) {
  return postCockpit('/alerts/list', data)
}

// D5 告警未读数 —— POST /alerts/unread-count（未读 = read_at IS NULL）
export function fetchAlertUnreadCount(data) {
  return postCockpit('/alerts/unread-count', data)
}

// D4 告警全部已读 —— POST /alerts/read
export function markAlertsRead(data) {
  return postCockpit('/alerts/read', data)
}
